import { useCallback } from "react";
import { ListingURLParamType } from "../utils";

// TODO: to be updated with a dynamic logic
export const getBaseOrigin = (origin: string) => {
  if (origin.endsWith(".shoppersdrugmart.ca")) {
    return origin.replace(/mypharmacy\./, "www.");
  }
  return origin;
};

/**
 * hook to update single query param to given url:
 */
export const useUpdateQueryParam = () => {
  return useCallback((param: Record<string, string>) => {
    const url = new URL(window.location.href);
    const baseOrigin = getBaseOrigin(url.origin);
    const newParams = new URLSearchParams();

    for (const [key, value] of Object.entries(param)) {
      const decodedValue = decodeURIComponent(value);
      newParams.set(key, decodedValue);
    }

    return `${baseOrigin}/search?${newParams.toString()}`;
  }, []);
};

export default useUpdateQueryParam;
